import PropTypes from 'prop-types';

const inspirePagePayloadType = PropTypes.shape({
  inspire_page_data: PropTypes.objectOf(PropTypes.object),
});

export default inspirePagePayloadType;
